export const domainEventPublishingMiddleware = ({ eventBus, domainEventsPublisher, domainEventsRecorder }) => async (command, next) => {
    await next(command);
    const events = domainEventsRecorder.recordedDomainEvents();
    await eventBus(events);
    domainEventsPublisher.publish(events);
};
